<div class="item-details d-flex align-items-center">
  <app-fbm-order-poduct-info [item]="params.data?.productDetailsList[0]" *ngIf="params.data?.productDetailsList?.length===1">
  </app-fbm-order-poduct-info>
  <ng-container *ngIf="params.data?.productDetailsList?.length>1">
    <div class="item-details-img" *ngFor="let data of params.data.productDetailsList;let i=index">
      <div (mouseover)="viewSingleProduct($event,data)" class="pointer" (mouseout)="closeDialog($event)">
        <img *ngIf="i < maxSize" [src]="data.image" (error)="data.image=noImage" alt="image">
      </div>

    </div>
    <div class="d-flex align-items-center item-details-details-wrap">
      <span class="item-details-more-product"
        *ngIf="params.data.productDetailsList?.length>maxSize">{{params.data.ProductDetailsList?.length -
        maxSize}}+</span>
      <span class="item-details-btn pointer" *ngIf="params.data?.productDetailsList?.length!==1"
        (click)="viewAllProducts($event,params.data.productDetailsList)">
        View all
      </span>
    </div>
  </ng-container>

</div>